import { SystemFuncArgs } from '@brochington/ecstatic';
import Canvas from 'editor/components/Canvas';
import Transform from 'editor/components/Transform';
import { Components } from '../components';

export const transformCanvasComponents = [Canvas, Transform];

export function transformCanvas(args: SystemFuncArgs<Components>): void {
  const { entity } = args;

  const canvasComp = entity.get(Canvas);
  const transformComp = entity.get(Transform);

  const ctx = canvasComp.canvas.getContext('2d');

  if (ctx) {
    const { transform: t } = transformComp;

    ctx.setTransform(t[0], t[1], t[4], t[5], t[12], t[13]);
  }
}
